//Dec15 FormDesignPage.jsx:
import React from 'react';
import { useParams } from 'react-router-dom'; // Import useParams
import { Box } from '@mui/material';
import SidePanel from '../components/FormSettings/SidePanel';
import ThemeSettings from '../components/FormSettings/FormThemeSettings/ThemeSettings';
import ThemeColors from '../components/FormSettings/FormThemeSettings/ThemeColors';  
import TypographySettings from '../components/FormSettings/FormThemeSettings/TypographySettings';  
import FullPageView from '../components/FormSettings/FormDesignViews/FullPageView';
import PaperThemeView from '../components/FormSettings/FormDesignViews/PaperThemeView'; 
import FieldVariantSettings from '../components/FormSettings/FormThemeSettings/FieldVariantSettings'; 
import ButtonStyleSettings from '../components/FormSettings/FormThemeSettings/ButtonStyleSettings'; 
import { useFormTheme } from '../contexts/FormThemeContext'; 
import LoadingScreen from '../components/LoadingScreen/LoadingScreen';  // Assuming you have a loading component

const FormDesignPage = () => {
  const { formId } = useParams(); // Retrieve formId from the route
  const { selectedTheme, themeLoading } = useFormTheme(); // Use the theme context to get the current theme and loading state

  const renderThemeView = () => {
    switch(selectedTheme) {
      case 'Paper':
        return <PaperThemeView />;
      default:
        return <FullPageView />;
    }
  };

//  console.log("Current Form ID:", formId); // Optional: For debugging to confirm the correct form ID
//  console.log("Theme Loading:", themeLoading); // Debugging theme loading state

  const formDesignSections = [
    {
      title: "Form Experience",
      items: [
        { element: <ThemeSettings /> }
      ]
    },
    {
      title: "Field Designs",
      items: [
        { element: <FieldVariantSettings /> }
      ]
    },
    {
      title: "Colors",
      items: [
        { element: <ThemeColors /> }
      ]
    },
    {
      title: "Typography",
      items: [
        { element: <TypographySettings /> }
      ]
    },
    {
      title: "Submit Button",
      items: [
        { element: <ButtonStyleSettings /> }
      ]
    },
  ];

  // Only render the UI when the theme is fully loaded
  if (themeLoading) {
    return <LoadingScreen />;  // Display loading screen while waiting for theme settings
  }

  return (
    <Box display="flex" height="100vh">
      <SidePanel 
        sections={formDesignSections} 
        onBack={() => {
          // e.g. navigate to another page, or hide the side panel, etc.
        }} 
      />
      <Box 
        flex={1} 
        bgcolor="#f0f0f0"
        sx={{ 
          overflowY: 'auto',  // 🆕 right-hand side scrolls independently
          minHeight: 0,       // 🆕 important for flex + overflow
        }}
      >
        {renderThemeView()}
      </Box>
    </Box>
  );
};

export default FormDesignPage;
